// extracted by mini-css-extract-plugin
export default {"appLoadingWrapper":"lUdHfS"};